@if (activeColumn$ | async) {
<span class="ml-1 text-gray-600">
  @if (reversed$ | async) { &#9660; } @if ((reversed$ | async) === false) { &#9650; }
</span>
}
